import React from "react";

export function WB_CoreHeaderOne({}) {
    return <div className="prose prose-base">
        <h1>Header One</h1>
    </div>
}